<template>
  <div>
    <v-dialog
      :value="value"
      @input="$emit('input', $event)"
      max-width="500"
      @keydown.esc="show = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Osamaksulaskuri</span>
          <v-spacer />
          <tk-btn icon @click="$emit('input', !value)">
            <v-icon>fas fa-times</v-icon>
          </tk-btn>
        </v-card-title>

        <v-card-text>
          <div class="part-payment-calculator" color="secondary"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["price", "value"],

  mounted() {
    this.mountCalculator();
  },

  methods: {
    mountCalculator() {
      let requestLocale = this.$i18n.locale;
      if (requestLocale === "se") requestLocale = "sv";

      console.log("Price", this.price);

      const scriptEl = document.createElement("script");
      scriptEl.setAttribute(
        "src",
        "https://payments.maksuturva.fi/tools/partpayment/partPayment.js"
      );
      scriptEl.setAttribute("class", "svea-pp-widget-part-payment");
      scriptEl.dataset["sellerid"] = "YROWGPZL";
      scriptEl.dataset["price"] = this.price;
      scriptEl.dataset["activeColor"] = "#212121";
      scriptEl.dataset["textColor"] = "#00AECE";
      scriptEl.dataset["highlightColor"] = "#002C50";
      scriptEl.dataset["borderColor"] = "#DEE1EC";
      scriptEl.dataset["borderRadius"] = "4";
      scriptEl.dataset["locale"] = requestLocale;
      scriptEl.onload = () => {
        const loadCalculatorEvent = document.createEvent("Event");
        /**
         * Aleksi promised to replace the DOMContentLoaded with
         * aksuturva-load-partpayment-calculator. So replace DOMContentLoaded
         * event with aksuturva-load-partpayment-calculator.
         */
        loadCalculatorEvent.initEvent("DOMContentLoaded", true, true);
        window.document.dispatchEvent(loadCalculatorEvent);
      };

      const cardEl = document.querySelector(".part-payment-calculator");
      cardEl.appendChild(scriptEl);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  overflow: hidden;
}
</style>
